<template>
  <div :class="'col-md-' + col + ' ' + setClass" class="input" :id="setId">
    <label :style="{'font-size': fontLabel}">{{ label }} <span v-if="isRequired">*</span></label>
    <div class="input-content">
      <input v-if="validateDaysOfTheMonth" v-mask="'##'" :name="name" v-model="contentText" :type="type"
             :placeholder="placeholder"
             :disabled="disabled"
             @change="validateInput"
             @keydown.enter="$emit('enter-pressed')">
      <input v-else-if="hasMaskMoney" v-money="money1" :name="name" v-model="contentText" :type="type"
             :placeholder="placeholder"
             :disabled="disabled"
             @keydown.enter="$emit('enter-pressed')">
      <input v-else-if="mask" v-mask="mask" :name="name" v-model="contentText" :type="type" :placeholder="placeholder"
             :disabled="disabled"
             @keydown.enter="$emit('enter-pressed')">
      <input v-else :name="name" v-model="contentText" :type="type" :placeholder="placeholder" :disabled="disabled"
             @keydown.enter="$emit('enter-pressed')">
      <svg v-if="haveIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.5 3C11.2239 3 12.8772 3.68482 14.0962 4.90381C15.3152 6.12279 16 7.77609 16 9.5C16 11.11 15.41 12.59 14.44 13.73L14.71 14H15.5L20.5 19L19 20.5L14 15.5V14.71L13.73 14.44C12.5505 15.4468 11.0507 15.9999 9.5 16C7.77609 16 6.12279 15.3152 4.90381 14.0962C3.68482 12.8772 3 11.2239 3 9.5C3 7.77609 3.68482 6.12279 4.90381 4.90381C6.12279 3.68482 7.77609 3 9.5 3ZM9.5 5C7 5 5 7 5 9.5C5 12 7 14 9.5 14C12 14 14 12 14 9.5C14 7 12 5 9.5 5Z"
          fill="#7E8DA7"/>
      </svg>

    </div>
    <span class="input-error" v-if="inputError && !fontError" :style="smallInput ? 'width: 112px;' : ''">Preencha o campo *</span>
    <span class="input-error" v-if="inputError && fontError && !errorValidate"
          :style="fontError ? 'font-size: 14px; bottom: -22px' : ''">Preencha o campo *</span>
    <span class="input-error" v-if="inputError && fontError && errorValidate"
          :style="fontError ? 'font-size: 14px; bottom: -22px' : ''">{{ errorValidate }}</span>
  </div>
</template>

<script>
export default {
  name: "inputText",
  props: {
    label: {
      required: true,
    },
    placeholder: {
      required: true,
    },
    type: {
      required: true,
    },
    isRequired: {
      default: false,
    },
    haveIcon: {
      default: false,
    },
    col: {
      required: true,
    },
    inputError: {
      default: false,
    },
    name: {
      default: ''
    },
    mask: {
      default: '',
    },
    hasMaskMoney: {
      default: false,
    },
    setId: {
      default: '',
    },
    setClass: {
      default: '',
    },
    smallInput: {
      default: false,
    },
    fontLabel: {
      default: ''
    },
    fontError: {
      default: false
    },
    valueDefault: {
      default: '',
    },
    errorValidate: {
      default: '',
    },
    validateDaysOfTheMonth: {
      default: false,
    },
    disabled: {
      default: false,
    }
  },
  data() {
    return {
      contentText: '',
      money1: {
        decimal: ".",
        thousands: ",",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
    }
  },
  methods: {
    validateInput() {
      let num = parseInt(this.contentText, 10);

      if (isNaN(num)) {
        this.contentText = "";
      } else if (num > 31) {
        this.contentText = "31";
      }
    },
  },
  watch: {
    contentText(newValue, oldValue) {
      this.$emit('contentText', newValue)
    }
  },
  beforeMount() {
    if (this.valueDefault !== '') {
      this.contentText = this.valueDefault;
    }
  }
}
</script>

<style lang="scss" scoped>

.input {
  position: relative;
  margin-bottom: 20px;

  label {
    font-size: 14px;
    font-weight: 400;
    color: #191919;
    margin-bottom: 4px;

    span {
      font-weight: 400;
      font-size: 14px;
      color: #FF445D;
    }
  }

  &-content {
    position: relative;

    input {
      width: 100%;
      background: #EEF2F7;
      border-radius: 4px !important;
      padding: 6px 12px;
      border: 1px solid #EEF2F7;
      transition: .2s;
      font-size: 16px;
      font-weight: 400;
      color: #3A424E;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;

      &::placeholder {
        font-size: 16px;
        font-weight: 400;
        color: #7E8DA7;
      }

      &:hover {
        transition: .2s;
        border: 1px solid #CACACA;
      }

      &:focus-visible {
        outline: none;
        transition: .2s;
        border: 1px solid #CACACA;

        &::placeholder {
          transition: .1s;
          color: #EEF2F7;
        }
      }
    }

    svg {
      position: absolute;
      right: 11px;
      top: 6px;
      font-size: 24px;
      color: #7E8DA7;
      pointer-events: none;
    }
  }

  &-error {
    position: absolute;
    left: 15px;
    bottom: -15px;
    font-size: 11px;
    color: #D9534F;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/inputs/inputText.vue